import styled from 'styled-components';

export const Wrapper = styled.div`
	background-position: center;
	background-size: cover;
	overflow: hidden;
	width: 100%;
	height: 100%;
`;



// WEBPACK FOOTER //
// ./src/containers/App/styles.js